// extracted by mini-css-extract-plugin
export var form = "search-form-module--form--898b0";
export var searchButton = "search-form-module--searchButton--75fc2";
export var searchInput = "search-form-module--searchInput--a1f58";